// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3gic7","col":"Table_col__GoTsE","fulfillmentStatus":"Table_fulfillmentStatus__36IXo","emailCol":"Table_emailCol__2vTkP"};